var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 8.5C9.324 8.5 10.5 7.23067 10.5 5.66667C11.949 5.66667 13.125 6.936 13.125 8.5C13.125 10.064 11.949 11.3333 10.5 11.3333C9.051 11.3333 7.875 10.064 7.875 8.5ZM0 8.5C0 6.58467 5.11612 0 10.5 0C15.8839 0 21 6.58467 21 8.5C21 10.4153 15.8839 17 10.5 17C5.11612 17 0 10.4153 0 8.5ZM5.25 8.5C5.25 11.6294 7.60069 14.1667 10.5 14.1667C13.3993 14.1667 15.75 11.6294 15.75 8.5C15.75 5.37058 13.3993 2.83333 10.5 2.83333C7.60069 2.83333 5.25 5.37058 5.25 8.5Z",
    fill: "#FF0A00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.267876a2.svg";
export { ForwardRef as ReactComponent };